import React from "react";
import Wave from "react-wavify";

const OpeningAnimatedLayer = () => {
  return (
    <div
      className={`z-[1000] gridAreaOne opacity-0 layer h-[99vh] flex flex-col items-center justify-start`}
    >
      <div className="greenWave h-[0%] w-full">
        <div className="bg-[#000] w-full h-full flex flex-col items-center justify-center"></div>
      </div>
      <Wave
        className="rotate-180 relative bottom-2"
        fill="#000"
        paused={false}
        options={{
          height: 0,
          amplitude: 30,
          speed: 0.3,
          points: 10,
        }}
      />
    </div>
  );
};

export default OpeningAnimatedLayer;
